import { Box } from '@mui/material';
import { useContext } from 'react';

import { UsersContext } from '@/Contexts/UsersContext';
import { UserType } from '@/models/User';

import ADFDashboard from './ADFDashboard';
import Dashboard from './Dashboard';
import Header from '../components/header/Header';
import DeadlineBanner from '@/components/dashboard_components/applicant_dashboard/DeadlineBanner';

export default function DashboardTemplate() {
  const { userType, userCurrent } = useContext(UsersContext);
  return (
    <Box
      display='flex'
      flexDirection='column'
      sx={{
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <DeadlineBanner />
      <Header />

      <Box display='flex' flex={1} minHeight={0}>
        {userType == UserType.Applicant ? (
          <Dashboard currentPartnerId={userCurrent?.currentPartnerId} />
        ) : (
          <ADFDashboard />
        )}
      </Box>
    </Box>
  );
}
